import API from '../api';

export const getOrganizationDashboard = ({ signal } = {}) =>
  API.get('/universities/organization_dashboard/', { signal }).then(
    (response) => response.data,
  );
